import { render, staticRenderFns } from "./NavChips.vue?vue&type=template&id=2d0aea54"
import script from "./NavChips.vue?vue&type=script&lang=ts"
export * from "./NavChips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports